exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-card {\n  width: 450px;\n  margin: 60px auto 0; }\n  .login-card .mat-card-title h4 {\n    margin: auto; }\n  .login-card md-card-content {\n    padding: 0 16px 16px; }\n\n.full-width {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/agatextscreens/login/login.component.scss
// module id = ../../../../../src/app/agatextscreens/login/login.component.scss
// module chunks = 0